import React from "react";
import { Link } from "react-router-dom";

import { toLocalTimeFromUTC, toLocalTimeFromUTCWithOffset } from "datetime";

import { EventData } from "..";

export const EventList = ({
  isLoading,
  eventData,
  linkMoreTo,
}: {
  isLoading: boolean;
  eventData: EventData[];
  linkMoreTo?: string;
}) => {
  if (isLoading) return <div>Loading...</div>;
  return (
    <div className="relative text-black">
      <div
        className="border-r-2 border-gray-500 absolute h-full top-0"
        style={{ left: "7px" }}
      ></div>
      <ul className="list-none m-0 p-0">
        {eventData.map((data, index) => (
          <li key={index} className="mb-2">
            <Link
              to={`/sites/${data.site_id}/units/${data.unit_id}/device/${data.device_id}/events/${data.timestamp_utc}/`}
              className="hover:bg-gray-300 cursor-pointer block"
            >
              <div className="flex items-center mb-1">
                <div className="bg-gray-500 rounded-full h-4 w-4"></div>
                <div className="flex-1 ml-4 font-medium">
                  <span
                    title={toLocalTimeFromUTCWithOffset(data.timestamp_utc)}
                  >
                    {toLocalTimeFromUTC(data.timestamp_utc)}
                  </span>{" "}
                  - {data.unit_id} / {data.device_id}
                </div>
              </div>

              <div className="ml-12">
                {data.event_text || "(no event text)"} (code {data.event_code},
                level {data.event_level})
              </div>
            </Link>
          </li>
        ))}
        {eventData.length === 0 && (
          <li>
            <div className="flex items-center mb-1">
              <div className="bg-gray-500 rounded-full h-4 w-4"></div>
              <div className="flex-1 ml-4 font-medium">
                No event data available
              </div>
            </div>
          </li>
        )}
        {linkMoreTo && eventData.length > 0 && (
          <li>
            <Link
              to={linkMoreTo}
              className="hover:bg-gray-300 cursor-pointer block"
            >
              <div className="flex items-center mb-1">
                <div className="bg-gray-500 rounded-full h-4 w-4"></div>
                <div className="flex-1 ml-4 font-medium">
                  Show more events...
                </div>
              </div>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};
